import axios from 'axios'
import { saveAs } from 'file-saver'

export const getSharedResourcesTable = (options = {}) => {
  const params = new URLSearchParams()
  params.append('pagination', JSON.stringify(options.pagination || {}))
  params.append('sort', JSON.stringify(options.sort || {}))
  params.append('tableFilter', JSON.stringify(options.tableFilter || {}))
  return axios.get(`/shared-resources/table?${params.toString()}`)
}

export const getSharedResourcesForContact = (contactId) => axios.get(`/shared-resources/contact/${contactId}`)

export const createSharedResource = (formData) => axios.post('/shared-resources', formData)

export const updateSharedResource = (id, data) => axios.patch(`/shared-resources/${id}`, data)

export const deleteSharedResource = (id) => axios.delete(`/shared-resources/${id}`)

/**
 * Streams the file through the API (the S3 objects are private — there is no public
 * URL) and hands it to the browser. A plain <a href> would not carry the JWT.
 */
export const downloadSharedResource = async (id, name) => {
  const response = await axios.get(`/shared-resources/${id}/download`, { responseType: 'blob' })
  saveAs(new Blob([response.data]), name || 'document')
}

/**
 * Read-only preview (VIEW grant, not DOWNLOAD): fetches the file as a blob and
 * returns an object URL for inline rendering. Caller must URL.revokeObjectURL it.
 */
export const fetchSharedResourcePreview = async (id) => {
  const response = await axios.get(`/shared-resources/${id}/preview`, { responseType: 'blob' })
  // blob is returned too so spreadsheets can be parsed client-side (SheetJS).
  return { url: URL.createObjectURL(response.data), type: response.data.type, blob: response.data }
}

/**
 * With responseType 'blob' a JSON error body arrives as a Blob, so err.response.data.error
 * is undefined and a naive handler shows nothing. Unwrap it (ftpFilesServices pattern).
 */
export const readApiError = async (error, fallback = 'Request failed') => {
  const data = error?.response?.data

  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text())
      return parsed?.error || parsed?.message || fallback
    } catch (parseError) {
      return fallback
    }
  }

  return data?.error || data?.message || error?.message || fallback
}
